import { render, staticRenderFns } from "./EditarProducao.vue?vue&type=template&id=05c1aae2&scoped=true"
import script from "./EditarProducao.vue?vue&type=script&lang=js"
export * from "./EditarProducao.vue?vue&type=script&lang=js"
import style0 from "./EditarProducao.vue?vue&type=style&index=0&id=05c1aae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c1aae2",
  null
  
)

export default component.exports